module.exports = __webpack_public_path__ + "assets/img/D4.aaf9292a.png";